<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col-12 space">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3">
              <router-link  to="/">{{$t("lawyerDetails.breadcrumb_1")}}</router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>

            <li class="active mx-3 almarai-bold" aria-current="page">
              {{$t("lawyerDetails.breadcrumb_2")}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row justify-content-end" v-if="billUrl">
      <div class="col-6 col-md-2 btn-bill">
        <a :href="BASE_URL+billUrl" target="_blank" type="application/pdf">
          <div>
            <img src="/assets/images/icons/receipt-text.png" class="max-22" alt="">
            <span class="mx-2">{{$t('invoiceDetails')}}</span>
          </div>
        </a>
      </div>
    </div>

    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <mainloader v-if="isLoading" />

    <div v-else class="row">
      <div class="col">
        <div class="row justify-content-center">
          <div class="col-12 col-md-10">
            <div class="card border-0">
              <div class="card-body">
                <h6 class="almarai-bold"></h6>
                <form action="">
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <label for="" class="p-content">
                        {{$t("lawyerDetails.fullName")}}
                      </label>
                      <div class="py-2 almarai-bold">{{value.name}}</div>
                      
                    </div>
                    <div class="col-12 col-md-4">
                      <label for="" class="p-content">
                        {{$t("lawyerDetails.mobile")}}
                      </label>
                      <div class="py-2 almarai-bold">{{value.mobile}}</div>
                    </div>
                  </div>

                  <div class="row pt-2">
                    <div class="col">
                      <label for="" class="p-content">
                        {{$t("lawyerDetails.description")}}
                      </label>
                      <div class="py-2 almarai-bold">{{value.subject}}</div>
                    </div>
                  </div>

                  <div class="row pt-2" v-if="canReply">
                    <div class="col-12">
                      <textarea v-model="reply" :placeholder="$t('detailsLegalinquiry')" class="form-control" rows="4"></textarea>
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validateError">
                      {{ validateMessage }}
                    </div>
                  </div>

                  <div class="row pt-3" v-if="canReply">
                    <div class="col-12">
                      <label class="p-content">{{$t('lawyerRequested.attachDocuments')}}</label>
                      <div class="uploadFile">
                        <label class="mouse-hand" for="upload" >
                          <img src="/assets/images/icons/file-up.png" class="max-28 py-2"  alt=""> <br>
                          <input type="file" id="upload" @change="uploadFile($event.target.files)" 
                            class="input-style d-none form-control" multiple accept="image/*,application/pdf"
                          >
                          <div class="font-color-3E font-12">{{$t('addAd.certifiedDocument')}}</div>
                          <div class="font-color-AB py-2">{{$t('addAd.supported_Fileformats')}}</div>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row pt-2">
                    <div class="col">
                      <label for="" class="orange-color almarai-bold py-3">
                        {{$t("lawyerDetails.comments")}}
                      </label>

                      <div class="card comments" v-for="(row,index) in LawyerReplies" :key="index">
                        <div class="card-body">
                          <div class="row" >
                            <div class="col-12 col-md-10 almarai-bold">
                              <div :class="(showMessage === index) ? 'preLine readLess' :'preLine readMore'">{{row.reply}}</div>
                              <div @click.prevent="toggleMessage(index)" class="readMore_Style mx-2">
                                {{showMessage === index ? 'عرض الاقل' : 'المزيد'}}
                              </div>
                            </div>
                            <div class="col-12 col-md-2 text-start p-content pt-3">
                              <!-- {{row.createdAt}} -->
                              {{moment(row.createdAt).format('lll a')}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row pt-5 justify-content-center" v-if="canReply">
                    <div v-if="loading" class="col-12 col-md-5 text-center">
                      <loader />
                    </div>
                    <div v-else class="col-12 col-md-5 text-center" @click.prevent="lawyerReqReply">
                      <div class="btn-green">{{$t('sendReply')}}</div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- begin:modal -->
    <div class="modal" id="popup_FreeOrder" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <p>حدث خطأ</p>
            <h6>الطلب مجاني أو غير مدفوع</h6>
            <div class="row">
              <div class="col-11 col-md-5">
                <div>الاستمرار</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- begin:Confirmation lawyer response -->
    <div class="modal bg-modal" id="lawyerResponse" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center py-2">
              <div class="col-12 text-center">
                <img src="/assets/images/icons/true-icon.png" class="max-50" alt="">
              </div>
            </div>
            <p class="text-center almarai-bold pt-2">{{$t('receivedReply')}}</p>
            <div class="row pt-3 justify-content-center">
              <div class="col-11 col-md-5 btn-green">
                <router-link class="text-white" to="/myrequests?dataType=legalConsultations">
                  <div>{{$t('continuation')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:Confirmation lawyer response -->
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
  name: 'lawyerRequestedDetails',

  data(){
    return{
      requestId: this.$route.params.id,
      hasError: false,
      message: '',
      errorNumber: null,
      isLoading: true,
      value: {},
      LawyerReplies: [],
      userLang: 'ar',
      billUrl: null,
      showMessage: null,
      canReply: null,
      reply: "",
      loading: false,
      attachments: [],
      validateMessage: this.$t('validateMessage'),
      validateError: false,
    }
  },

  computed: {
    ...mapGetters(['BASE_URL'])
  },

  methods:{
    lawyerDetails(){
      this.$http.get('/api/lawyerReq/retrieve/'+this.requestId).then(res => {
        // console.log(res);
        this.value = res.data.row;
        this.LawyerReplies = res.data.row.LawyerReplies;
        this.canReply = res.data.canReply;
        this.getBill();
        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },
    charsOnly(e) {
      // keep only Arabic letters, Latin letters, and spaces
      // requires modern JS regex support for Unicode property escapes
      const char = e.key;
      const allowed = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FFA-Za-z\s]$/;

      if (!allowed.test(char)) {
        e.preventDefault(); // block the input
      }
    },
    moment,
    formatDate(){
      if(this.userLang == 'ar'){
        moment.locale(this.formatedDate);
      }else{
        moment.locale(this.fallbackLang);
      }
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime);
    },

    getBill(){
      this.$http.get('/api/bills/LawyerRequests/'+this.requestId).then(res => {
        if(res.data.url)
        this.billUrl = res.data.url
      }).catch(() => {});
    },

    toggleMessage(index){
      this.showMessage = this.showMessage === index ? null : index;
    },

    uploadFile(files) {
      this.attachments = [...files];
    },

    lawyerReqReply(){
      if(!this.reply){
        this.validateMessage;
        this.validateError = true;
        return false;
      }

      this.loading = true;
      const formData = new FormData();
      formData.append('reply', this.reply);
      // if(this.requestId){
      //   formData.append('id', parseInt(this.requestId));
      // }
      if(this.attachments && this.attachments.length){
        for(let file =0; file < this.attachments.length; file++){
          formData.append('attachments',this.attachments[file]);
        }
      }
      this.$http.post('/api/lawyerReq/reply/'+this.requestId,formData).then(res => {
        document.getElementById('lawyerResponse').style.display = "block";
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
      })
    }

  },
  created(){
    this.lawyerDetails();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior: 'smooth'})
  }
}
</script>